import { headTags } from 'lib/const/favicon';
import { ThemeTypes, THEME_LABELS } from 'lib/context/theme/types';
import { IUserData } from '../users/getUser';
import { IWhiteLabel } from './getWhiteLabel';

export const getThemeByWhiteLabel = (
  whitelabel: IWhiteLabel | undefined,
  user: IUserData | undefined
) => {
  if (!whitelabel) {
    return 'covideoTheme' as keyof ThemeTypes;
  }
  if (whitelabel.name === 'Covideo') {
    const hasAutomotiveAccess =
      user?.customer?.automotiveAccess?.toString() === '1';
    return hasAutomotiveAccess ? THEME_LABELS.AUTOMOTIVE : THEME_LABELS.COVIDEO;
  }
  return whitelabel.name as keyof ThemeTypes;
};

export const createLinksInHeadTagLinks = (whitelabel: IWhiteLabel) => {
  const headID = document.getElementsByTagName('head')[0];

  const baseUrl = 'https://' + whitelabel.domainV2 + whitelabel.contentPath;
  headTags.forEach(tag => {
    const tagType = Object.keys(tag)[0];
    const link = document.createElement(tagType);
    // @ts-ignore
    const attributes = tag[tagType];
    for (const key in attributes) {
      // @ts-ignore
      key == 'href'
        ? // @ts-ignore
          (link[key] = baseUrl + attributes[key])
        : // @ts-ignore
          (link[key] = attributes[key]);
    }
    headID.appendChild(link);
  });
};
